<template>
  <div>
    <b-row class="my-3">
      <b-col sm="12">
        <b-card class="chr-card-tour">
          <b-card-header class="px-2">
            <ResultHeader :result="result" :selected="selected" @toggle="$emit('toggle')" @info="$emit('info')"/>
          </b-card-header>
          <b-card-body class="p-0">
            <DACD :result="result" />
            <b-row class="mb-3">
              <b-col sm="3">
                <img v-if="result.images.length" :src="result.images[0]" class="img-thumbnail shadow-sm"/>
                <img v-else src="@/assets/images/default-image.jpg" class="img-thumbnail shadow-sm"/>
              </b-col>
              <b-col sm="9">
                <b-row>
                  <b-col sm="12">
                    <p style="white-space: pre-line;" class="small">
                      {{ result.description }}
                    </p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <h6 class="border-0" v-translate>Departure dates</h6>
                    <b-card no-body class="border-top-0">
                      <Dates :result="result" @selectDate="onSelectDate($event)" @showPriceDetails="onShowPriceDetails"/>
                    </b-card>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="1">
                <h6 v-b-toggle="`included-${result.id} not-included-${result.id}`"><b-icon icon="caret-down-fill"/></h6>
              </b-col>
              <b-col sm="6">
                <h6 class="d-flex justify-content-between align-items-center px-2 font-weight-bolder"  v-b-toggle="`included-${result.id}`">
                  <span v-translate>Included</span>
                  <span>
                    <span><b-icon icon="caret-down-fill"/></span>
                  </span>
                </h6>
                <b-collapse :id="`included-${result.id}`">
                  <b-card >
                    <p class="small" style="white-space: pre-line;">
                    {{ result.included }}
                  </p>
                  </b-card>
                </b-collapse>
              </b-col>
              <b-col sm="5">
                <h6 class="d-flex justify-content-between align-items-center px-2 font-weight-bolder" v-b-toggle="`not-included-${result.id}`">
                  <span v-translate >Not included</span>
                  <span>
                    <span><b-icon icon="caret-down-fill"/></span>
                  </span>
                </h6>
                <b-collapse :id="`not-included-${result.id}`">
                  <b-card>
                    <p class="small" style="white-space: pre-line;">
                      {{ result.not_included }}
                    </p>
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!--price details modal-->
    <b-modal v-model="priceDetailsModal" :title="$gettext('Price Details')" size="xl" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <TourPriceDetails :tour="result" :date="selectedDate"/>
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
  </div>
</template>

<script>
import ResultHeader from './result_header.vue'
import SimpleModalHeader from '@/app/private/shared/components/simple_modal_header'
import DACD from './dacd.vue'
import Dates from './dates.vue'

import TourPriceDetails from '../components/tour_price_details.vue'
import ModalFooter from '@/app/private/shared/components/modal_footer'

export default {
  name: 'Result',
  components: {
    ResultHeader,
    DACD,
    Dates,
    TourPriceDetails,
    SimpleModalHeader,
    ModalFooter
  },
  props: {
    result: {
      type: Object,
      mandatory: true
    },
    params: {
      type: Object,
      mandatory: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rooms: [{ adults: 2, ages: [] }],
      priceDetailsParams: {
        result: {},
        meal: null,
        title: null,
        discounts: []
      },
      lastSearchParams: {},
      modal: false,
      priceDetailsModal: false,
      selectedDate: null
    }
  },
  methods: {
    onSelectDate (date) {
      const route = {
        name: 'Private/Tour/Date',
        params: {
          tour: this.result.id,
          date: date.date
        }
      }
      this.$router.push(route)
    },
    onShowPriceDetails (date) {
      this.selectedDate = date
      this.priceDetailsModal = true
    },
    closePriceDetailsModal () {
      this.priceDetailsModal = false
    }
  }
}
</script>
